import { Plus, GitBranch, Loader2, IdCard, Layers } from "lucide-react";
import { Button } from "../components/ui/button";
import { GiftDuckButton } from "./GiftDuckButton";
import { passportUrl, labelsUrl } from "../lib/api";

// Top action row of a finished duck: make another, branch a v+1 variant, print the passport card, gift it to a friend.
export const DuckActionsRow = ({ creation, height, onNew, onBranch, busy }) => (
  <div data-testid="duck-actions-row" className="flex flex-wrap gap-2">
    {onNew && (
      <Button data-testid="new-duck-btn" variant="outline" onClick={onNew} className="rounded-full gap-2 h-11">
        <Plus className="h-4 w-4" /> Make another duck
      </Button>
    )}
    {onBranch && (
      <Button data-testid="branch-duck-btn" variant="secondary" onClick={onBranch} disabled={!!busy} className="rounded-full gap-2 h-11 font-semibold">
        {busy === "branch" ? <Loader2 className="h-4 w-4 animate-spin" /> : <GitBranch className="h-4 w-4" />}
        {busy === "branch" ? "Rendering variant…" : `Branch this duck → Rev ${(creation.version || 1) + 1}`}
      </Button>
    )}
    {creation.build_status === "ready" && (
      <a href={`${passportUrl(creation.id)}?height=${height || 70}`} target="_blank" rel="noreferrer" data-testid="passport-link">
        <Button variant="outline" className="rounded-full gap-2 h-11">
          <IdCard className="h-4 w-4" /> Print passport
        </Button>
      </a>
    )}
    {creation.build_status === "ready" && (
      <a href={`${labelsUrl(creation.id)}?height=${height || 70}`} target="_blank" rel="noreferrer" data-testid="labels-link">
        <Button variant="outline" className="rounded-full gap-2 h-11">
          <Layers className="h-4 w-4" /> Rollo labels
        </Button>
      </a>
    )}
    {creation.build_status === "ready" && <GiftDuckButton id={creation.id} height={height || 70} />}
  </div>
);
